document.addEventListener('DOMContentLoaded', function() {
  customColorSwatchTrigger();
});
function customColorSwatchTrigger(){
  const collectionCards = document.querySelectorAll('.product-card-wrapper');
  collectionCards.forEach(function(card) {
      const colorSwatches = card.querySelectorAll('.color-swatches button');
      const activeButton = Array.from(colorSwatches).find( b => b.classList.contains('active') );
  
      colorSwatches.forEach(function(button, index) {
          button.addEventListener('click', function() {
            console.log("button", card);
              activeColor(card,button)
          });
      });
  
      if (activeButton) {
          activeColor(card, activeButton);
      } else if (colorSwatches.length > 0 && !activeButton) {
          activeColor(card, colorSwatches[0]);
      }
  });

  const customFeaturedProducts = document.querySelectorAll('.custom-featured-product--info');
  customFeaturedProducts.forEach(function(card) {
      const colorSwatches = card.querySelectorAll('.color-swatches button');
      const activeButton = Array.from(colorSwatches).find( b => b.classList.contains('active') );
  
      colorSwatches.forEach(function(button, index) {
          button.addEventListener('click', function() {
            console.log("button", card);
              activeColor(card,button)
          });
      });
  
      if (activeButton) {
          activeColor(card, activeButton);
      } else if (colorSwatches.length > 0 && !activeButton) {
          activeColor(card, colorSwatches[0]);
      }
  });
}
function activeColor(card,button) {
    card.querySelectorAll('.color-swatches button').forEach(function(b) {
        b.classList.remove('active');
    });

    button.classList.add('active');
    const imageURL = button.getAttribute('data-image');
    if(window.innerWidth <= 749){
      if(card.querySelector('.product-second-image-changable')){
        card.querySelector('.product-second-image-changable').src = `${imageURL}`;
        card.querySelector('.product-second-image-changable').setAttribute('srcset',`${imageURL}`);
      }
      if(card.querySelector('.product-first-image-changable')){
        card.querySelector('.product-first-image-changable').src = `${imageURL}`;
        card.querySelector('.product-first-image-changable').setAttribute('srcset',`${imageURL}`);
      }     
    }else{
      if(card.querySelector('.product-second-image-changable')){
        card.querySelector('.product-second-image-changable').src = `${imageURL}`;
        card.querySelector('.product-second-image-changable').setAttribute('srcset',`${imageURL}`);
      }else if(card.querySelector('.product-first-image-changable')){
        card.querySelector('.product-first-image-changable').src = `${imageURL}`;
        card.querySelector('.product-first-image-changable').setAttribute('srcset',`${imageURL}`);
      }
    }
    
}
const loadRecommendationSlider = () => {
  const swiper =  new Swiper('.custom-recommendations-swiper-slider', {
    loop: false,
    slidesPerView: 1.1,
    spaceBetween: 20,
    pagination: {
      el: `.custom-recom-slider__pagination`,
      clickable: true,
    },
    navigation: {
      nextEl: `.custom-recom-slider-swiper-button-next`,
      prevEl: `.custom-recom-slider-swiper-button-prev`,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1250: {
        slidesPerView: 4,
        spaceBetween: 20,
      }
    }
  });
}
const loadCartRecommendationSlider = () => {
  const swiper =  new Swiper('.cart-custom-recommendations-swiper-slider', {
    loop: false,
    slidesPerView: 1.2,
    spaceBetween: 10,
    navigation: {
      nextEl: `.custom-recom-cart-slider-swiper-button-next`,
      prevEl: `.custom-recom-cart-slider-swiper-button-prev`,
    },
    breakpoints: {
      640: {
        slidesPerView: 1.4,
        spaceBetween: 10,
      }
    }
  });
}

class CartRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}&limit=3`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
        if (html.querySelector('.custom-recom-slide')) {
           this.classList.add('cart-recommendations--loaded');
           setTimeout(loadCartRecommendationSlider,500);
        }
        
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('cart-recommendations', CartRecommendations);

class DeliveryDate extends HTMLElement{
  observer = undefined;

  constructor() {
    super();
    this.minday = parseInt(this.dataset.min) || 0;
    this.maxday = parseInt(this.dataset.max) || null;
  }

  connectedCallback() {
    this.initDate();
  }

  formatDate(date) {
    if (window.innerWidth < 749) {
      var options = { month: 'short', day: 'numeric' };
    } else {
      var options = { month: 'long', day: 'numeric' };
    }
    return date.toLocaleDateString('en-US', options);
  }

  calculateDeliveryDates(startDayOffset, endDayOffset = null) {
    var today = new Date();
    var deliveryStart = new Date(today);
    deliveryStart.setDate(deliveryStart.getDate() + startDayOffset);

    if (endDayOffset === null) {
      return [this.formatDate(deliveryStart)];
    }

    // Calculate end date from today, not from start date
    var deliveryEnd = new Date(today);
    deliveryEnd.setDate(deliveryEnd.getDate() + endDayOffset);
    
    return [this.formatDate(deliveryStart), this.formatDate(deliveryEnd)];
  }

  initDate(){
    var dates = this.calculateDeliveryDates(this.minday, this.maxday);
    console.log(dates, "delivery dates");
    
    if(dates.length > 1){
      if(this.querySelector(".custom-date-from")){
         this.querySelector(".custom-date-from").textContent = dates[0];
      }
      if(this.querySelector(".custom-date-to")){
        this.querySelector(".custom-date-to").textContent = dates[1];
      }
      
    } else {
      if(this.querySelector(".custom-date-from")){
         this.querySelector(".custom-date-from").textContent = dates[0];
      }
     
      // Clear the "to" date if it exists
      const toElement = this.querySelector(".custom-date-to");
      if (toElement) {
        toElement.textContent = "";
      }
    }
    this.classList.remove("hidden");
  }
}

customElements.define('delivery-date', DeliveryDate);

function animateCounter(element, start, end, duration) {
  console.log(element, start, end, duration);
    let startTimestamp = null;
    const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        
        // Easing function for smooth animation
        const easeOutQuart = 1 - Math.pow(1 - progress, 4);
        const current = Math.floor(easeOutQuart * (end - start) + start);
        
        element.textContent = current.toLocaleString();
        
        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    };
    window.requestAnimationFrame(step);
}

document.addEventListener('DOMContentLoaded', function() {
  if(document.querySelector(".custom-number-counter")){
    const customCounter = document.querySelector(".custom-number-counter");
    const numberText = Number(customCounter.textContent);
    const startNumber = (numberText * .90);
     animateCounter(customCounter, startNumber, numberText, 1000);
  }
  const allAnchorButtons = document.querySelectorAll(".custom-anchor-button");
  if(allAnchorButtons.length > 0){
    allAnchorButtons.forEach((el) => {
      el.addEventListener("click",(evt) => {
        evt.preventDefault();
        const targetElement = document.querySelector(`#${el.dataset.target}`);
        if(targetElement){
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
          });
        }
      });
    });
  }
});


// For custom popup
document.addEventListener('DOMContentLoaded', function() {
    function initializePopup(openBtnSelector, popupSelector, closeBtnSelector) {
      const openPopupBtns = document.querySelectorAll(openBtnSelector);
      const myPopup = document.querySelector(popupSelector);
      const closePopupBtns = myPopup ? myPopup.querySelectorAll(closeBtnSelector) : null;

      if (!myPopup) {
        console.error(`Popup element not found with selector: ${popupSelector}`);
        return;
      }

      // --- Open Popup Listeners ---
      openPopupBtns.forEach(btn => {
        btn.addEventListener('click', function() {
          myPopup.style.display = 'block'; // Show the popup
        });
      });

      // --- Close Popup Listeners (for close button inside the popup) ---
      if (closePopupBtns) {
        closePopupBtns.forEach(btn => {
          btn.addEventListener('click', function() {
            myPopup.style.display = 'none'; // Hide the popup
          });
        });
      }

      // --- Close Popup Listeners (for clicking outside the content area) ---
      myPopup.addEventListener('click', function(event) {
        if (event.target === myPopup) {
          myPopup.style.display = 'none';
        }
      });
    }
    initializePopup('.win_popup_btn', '.win-gold-popup-wrapper', '.popup-close');
  });
  